"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class StripeSession extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'stripeSession';
        this._url = initParams.url;
    }
    set url(value) {
        console.error('Do not set objects this way');
    }
    get url() {
        return this._url;
    }
}
exports.default = StripeSession;
//# sourceMappingURL=stripeSession.js.map